module.exports = __webpack_public_path__ + "media/src/images/Danielle-Walker-ce0dd3a1a204e7899aad6124ed75a9a2.jpg";